// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const swordsTarotCards = [
  {
    image_description: "",
    id: 50,
    name_en: "Ace of Swords",
    name_hi: "तलवार का इक्का",
    vedic_name: "Vivek Khadga (Sword of Discernment)",
    vedic_parallel: "Like Vishnu's Sudarshan Chakra — the clarity that cuts through all illusion",
    upright: {
      keywords: ["clarity", "truth", "breakthrough", "new idea", "mental force"],
      meaning: "A breakthrough in clarity. The mind is sharp and truth is revealed.",
      advice: "Speak and act from truth. This clarity is a gift — use it.",
    },
    reversed: {
      keywords: ["confusion", "misinformation", "clouded judgment", "chaos"],
      meaning: "Mental fog or information overload. The truth is obscured.",
      advice: "Wait for clarity before making decisions.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 51,
    name_en: "Two of Swords",
    name_hi: "तलवार का दो",
    vedic_name: "Dwandva (The Dilemma)",
    vedic_parallel: "Like Arjuna's moral crisis — caught between two equally valid obligations",
    upright: {
      keywords: ["difficult choice", "stalemate", "avoidance", "blocked emotions"],
      meaning: "A decision is avoided because both options carry weight. Stalemate.",
      advice: "Remove the blindfold. Information you are ignoring holds the answer.",
    },
    reversed: {
      keywords: ["information overload", "indecision", "release of tension"],
      meaning: "The stalemate breaks. New information forces a choice.",
      advice: "Decide now. Further delay only increases the cost.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 52,
    name_en: "Three of Swords",
    name_hi: "तलवार का तीन",
    vedic_name: "Hridaya Vedana (Heartbreak)",
    vedic_parallel: "Like Sita's banishment — a pain that is real and must be felt fully",
    upright: {
      keywords: ["heartbreak", "sorrow", "grief", "painful truth", "betrayal"],
      meaning: "A painful truth or heartbreak. This pain is real and demands acknowledgment.",
      advice: "Feel the grief fully. Suppressed pain becomes bitterness.",
    },
    reversed: {
      keywords: ["healing", "forgiveness", "releasing pain", "recovery"],
      meaning: "The worst of the pain passes. Healing is underway.",
      advice: "Allow the wound to close. Reopening it serves no one.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 53,
    name_en: "Four of Swords",
    name_hi: "तलवार का चार",
    vedic_name: "Vishram (The Rest)",
    vedic_parallel:
      "Like a warrior in retreat between battles — rest is preparation, not surrender",
    upright: {
      keywords: ["rest", "recovery", "meditation", "contemplation", "retreat"],
      meaning: "Rest and recover. The mind needs stillness to regain its edge.",
      advice: "Retreat is not defeat. Restoration prepares you for what is next.",
    },
    reversed: {
      keywords: ["restlessness", "burnout", "inability to rest", "re-entering too soon"],
      meaning: "You are returning to action before recovery is complete.",
      advice: "Give yourself more time. Rushing back will cost more than waiting.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 54,
    name_en: "Five of Swords",
    name_hi: "तलवार का पाँच",
    vedic_name: "Apajay (The Hollow Victory)",
    vedic_parallel: "Like Ashwatthama's final attack — a victory that brings no honor",
    upright: {
      keywords: ["conflict", "defeat", "winning at a cost", "betrayal", "ego"],
      meaning: "A battle won but at great cost. Was the victory worth what was lost?",
      advice: "Know when winning is losing. Pyrrhic victories are not victories.",
    },
    reversed: {
      keywords: ["reconciliation", "compromise", "moving on", "learning from defeat"],
      meaning: "The conflict ends. It is time to learn and move forward.",
      advice: "Let go of the need to be right. Peace is more valuable than victory.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 55,
    name_en: "Six of Swords",
    name_hi: "तलवार का छह",
    vedic_name: "Prasthan (The Departure)",
    vedic_parallel: "Like the Pandavas leaving for vanavasa — difficult transition toward peace",
    upright: {
      keywords: ["transition", "moving on", "leaving behind", "calmer waters"],
      meaning: "Moving away from turbulence toward calmer waters. Difficult but necessary.",
      advice: "The hardest part is leaving. The journey itself brings healing.",
    },
    reversed: {
      keywords: ["stuck", "unable to move on", "unresolved issues", "resistance"],
      meaning: "You know you need to move on but cannot bring yourself to leave.",
      advice: "What you carry from the past weighs more than the journey ahead.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 56,
    name_en: "Seven of Swords",
    name_hi: "तलवार का सात",
    vedic_name: "Chhal (The Deception)",
    vedic_parallel: "Like Shakuni's loaded dice — strategy that crosses into manipulation",
    upright: {
      keywords: ["deception", "strategy", "cunning", "stealth", "betrayal"],
      meaning: "Someone is not being honest — possibly you. Strategy has crossed into deception.",
      advice: "Check your methods. Are you being clever or dishonest?",
    },
    reversed: {
      keywords: ["truth revealed", "confession", "coming clean", "getting caught"],
      meaning: "Deception is uncovered. The truth surfaces whether you want it to or not.",
      advice: "Come clean now. Being caught is worse than confessing.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 57,
    name_en: "Eight of Swords",
    name_hi: "तलवार का आठ",
    vedic_name: "Mana Bandhan (Mental Bondage)",
    vedic_parallel: "Like a bird that forgets the cage door is open — self-imposed limitation",
    upright: {
      keywords: ["restriction", "imprisonment", "helplessness", "self-limitation", "victim"],
      meaning: "You feel trapped, but the prison is mental. The restrictions are self-imposed.",
      advice: "Open your eyes. The way out exists — you just cannot see it yet.",
    },
    reversed: {
      keywords: ["freedom", "new perspective", "release", "empowerment"],
      meaning: "The blindfold falls. You realize you were never truly trapped.",
      advice: "Step forward. Freedom was always one thought away.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 58,
    name_en: "Nine of Swords",
    name_hi: "तलवार का नौ",
    vedic_name: "Chinta (The Anguish)",
    vedic_parallel: "Like Kunti's lifelong secret — anxiety that grows in the dark of night",
    upright: {
      keywords: ["anxiety", "nightmare", "worry", "guilt", "mental torment"],
      meaning: "Anxiety and worry dominate, often worse than reality. The mind torments itself.",
      advice: "Speak your fears aloud. They shrink in daylight.",
    },
    reversed: {
      keywords: ["hope", "recovery from anxiety", "facing fears", "release"],
      meaning: "The worst has passed or was never as bad as imagined.",
      advice: "Breathe. The dawn is already here.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 59,
    name_en: "Ten of Swords",
    name_hi: "तलवार का दस",
    vedic_name: "Param Patan (The Final Fall)",
    vedic_parallel: "Like Bhishma on the bed of arrows — the end is absolute, but the sun rises",
    upright: {
      keywords: ["rock bottom", "painful ending", "betrayal", "loss", "finality"],
      meaning: "The worst is over because it has already happened. This is the bottom.",
      advice: "Look at the horizon, not the swords. The only direction from here is up.",
    },
    reversed: {
      keywords: ["recovery", "survival", "worst is over", "resilience"],
      meaning: "You survived what you thought would end you. Recovery begins.",
      advice: "Rise. You are stronger than what broke you.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 60,
    name_en: "Page of Swords",
    name_hi: "तलवार का राजकुमार",
    vedic_name: "Vayu Shishya (The Air Student)",
    vedic_parallel:
      "Like young Nachiketa questioning Yama — sharp, curious, fearlessly inquisitive",
    upright: {
      keywords: ["curiosity", "new ideas", "communication", "mental energy"],
      meaning: "Sharp curiosity and new ideas. A message or insight arrives.",
      advice: "Ask the hard questions. Your curiosity is leading somewhere.",
    },
    reversed: {
      keywords: ["gossip", "hasty words", "scattered thoughts", "deception"],
      meaning: "Words used carelessly. Quick tongue, slow thinking.",
      advice: "Think before you speak. Not every thought needs an audience.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 61,
    name_en: "Knight of Swords",
    name_hi: "तलवार का शूरवीर",
    vedic_name: "Vayu Veer (The Air Warrior)",
    vedic_parallel: "Like Parashurama — swift, decisive, sometimes recklessly just",
    upright: {
      keywords: ["ambition", "action-oriented", "fast thinking", "determination"],
      meaning: "Swift, decisive action. A force that cuts through delays and hesitation.",
      advice: "Act fast but think faster. Speed with accuracy is power.",
    },
    reversed: {
      keywords: ["impulsive", "harsh words", "thoughtless action", "aggression"],
      meaning: "Too fast, too sharp. Words or actions cut people unnecessarily.",
      advice: "Slow your blade. Not everything deserves a fight.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 62,
    name_en: "Queen of Swords",
    name_hi: "तलवार की रानी",
    vedic_name: "Vayu Devi (The Air Queen)",
    vedic_parallel:
      "Like Vidula inspiring her son — clarity, directness, and emotional independence",
    upright: {
      keywords: ["clarity", "independence", "honest communication", "perceptiveness"],
      meaning: "Clear, honest perception. You see truth and speak it without apology.",
      advice: "Be direct but kind. Truth delivered with care changes lives.",
    },
    reversed: {
      keywords: ["cold", "bitter", "overly critical", "cruel honesty"],
      meaning: "Honesty has become cruelty. Emotional distance pushes people away.",
      advice: "Soften the delivery without diluting the truth.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
  {
    image_description: "",
    id: 63,
    name_en: "King of Swords",
    name_hi: "तलवार का राजा",
    vedic_name: "Vayu Nayak (The Air King)",
    vedic_parallel:
      "Like Bhishma in the court — authority through intellect, justice without sentiment",
    upright: {
      keywords: [
        "intellectual authority",
        "truth",
        "fair judgment",
        "analytical",
        "clear thinking",
      ],
      meaning: "Authority earned through intellect and fairness. Just, analytical, and principled.",
      advice: "Lead with your mind. Fairness is your greatest strength.",
    },
    reversed: {
      keywords: ["tyranny of logic", "cold authority", "manipulation", "abuse of power"],
      meaning: "Logic without heart becomes tyranny. Intellectual superiority used to dominate.",
      advice: "Justice requires compassion. A ruling without heart is oppression.",
    },
    arcana: "minor",
    suit: "swords",
    element: "air",
    vedic_element: "vayu",
    suit_theme: "Intellect, truth, conflict, and mental clarity",
  },
] as const satisfies readonly TarotReferenceCard[];
